import { useLanguage } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee-section"
      className="bg-white border-y border-slate-200 py-6 overflow-hidden"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span
              className={`font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight px-8 ${
                i % 2 === 0 ? "text-slate-900" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="w-2.5 h-2.5 bg-[#E31E24] rotate-45 shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
